import tinycolor from 'tinycolor2';

/**
 * El color del cliente, corrido lo justo para que se distinga sobre `fondo`.
 *
 * Es identidad, no paleta: se usa en detalles chicos (un punto, un filete) y
 * nunca en botones, enlaces, estados ni gráficos, que siguen con la marca de
 * FARO. Aun así tiene que verse: si no llega a 3:1 contra el fondo (el mínimo
 * de WCAG para elementos gráficos), se oscurece sobre fondo claro o se aclara
 * sobre fondo oscuro, sin tocar el matiz.
 *
 * Devuelve `undefined` si el color no es válido: quien lo usa cae al cyan.
 */
export function colorClienteLegible(color: string | undefined, fondo: string): string | undefined {
  if (!color) return undefined;
  const base = tinycolor(color);
  if (!base.isValid()) return undefined;

  const sobreOscuro = tinycolor(fondo).isDark();
  let c = base.clone().setAlpha(1);
  for (let paso = 0; paso < 20 && tinycolor.readability(c, fondo) < 3; paso++) {
    c = sobreOscuro ? c.lighten(4) : c.darken(4);
  }
  return c.toHexString();
}

/** Los fondos contra los que se mide: superficie clara y oscura de la marca. */
export const FONDO_CLARO = '#ffffff';
export const FONDO_OSCURO = '#1a1e2e';
/** El menú lateral es oscuro en los dos temas (`--barra-lateral-fondo`). */
export const FONDO_MENU = '#0d2a35';
